import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55dd3712&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=55dd3712&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd3712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dd3712')) {
      api.createRecord('55dd3712', component.options)
    } else {
      api.reload('55dd3712', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=55dd3712&scoped=true", function () {
      api.rerender('55dd3712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/pagination/IkPagination/index.vue"
export default component.exports